import { Recipient } from 'api/api';

export const getBillingAddressCandidate = (addressList?: Recipient[], recipient?: Recipient) => {
  if (!addressList || addressList.length <= 1) {
    return undefined;
  }
  return addressList.filter(address => address.id !== recipient?.id)[0];
};
